// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"940c36e3","884":"7e268fea"}[chunkId] + ".chunk.css";
};